/*
 * VIEA Custom JS — small helpers for global styling/behaviour
 * BY CLICKMOUSE
 */

(function() {
  
  // Strikethrough base entries text in product cards
  // Matches any rte-formatter paragraph with "X ENTRIES" pattern
  function applyEntriesStrikethrough(root) {
    root = root || document;
    root.querySelectorAll('rte-formatter p').forEach(function(p) {
      if (p.classList.contains('viea-base-entries')) return; // already processed
      var text = p.textContent.trim();
      if (/^\d+\s+ENTRIES$/i.test(text)) {
        p.classList.add('viea-base-entries');
      }
    });
  }
  
  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      applyEntriesStrikethrough();
    });
  } else {
    applyEntriesStrikethrough();
  }
  
  // Re-run when Shopify section reloads in theme editor
  document.addEventListener('shopify:section:load', function(e) {
    applyEntriesStrikethrough(e.target);
  });
  
  // Watch for dynamically-loaded content (e.g. recommended products, ajax-loaded cards)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // element node
          applyEntriesStrikethrough(node);
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();

// Contact form tab switching with URL hash support
  function initContactTabs() {
    var container = document.querySelector('.viea-contact-tabs');
    if (!container) return;
    
    var tabs = container.querySelectorAll('.viea-contact-tabs__tab');
    var panels = container.querySelectorAll('.viea-contact-tabs__panel');
    
    function showTab(tabName) {
      tabs.forEach(function(tab) {
        var isActive = tab.dataset.tab === tabName;
        tab.classList.toggle('viea-contact-tabs__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      panels.forEach(function(panel) {
        var isActive = panel.dataset.panel === tabName;
        panel.classList.toggle('viea-contact-tabs__panel--active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      
      // Update URL hash without scrolling
      if (history.replaceState) {
        history.replaceState(null, '', '#' + tabName);
      }
    }
    
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        showTab(this.dataset.tab);
      });
    });
    
    // Open tab from URL hash on page load
    var hash = window.location.hash.replace('#', '');
    if (['general', 'import', 'export'].indexOf(hash) !== -1) {
      showTab(hash);
    }
  }
  
  // Init contact tabs on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactTabs);
  } else {
    initContactTabs();
  }

  // --- Dr Free Gift integration ---
// Exposes window.refreshCart so the Dr Free Gift app can trigger a cart
// refresh without a full page reload when a free gift is added.
// Now defined in viea-cart-upsell-widget.js for full cart refresh handling

// window.refreshCart = async function() {
//   document.dispatchEvent(new CustomEvent('cart:update', {
//     bubbles: true,
//     detail: {
//       sourceId: 'dr-free-gift',
//       data: { source: 'dr-free-gift' }
//     }
//   }));
// };